<template>
    <div v-if="registration">
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-lg-7 order-lg-2">
                    <registration :registration="registration" :showButtons="false"></registration>

                    <tabs class="tabs"
                        tabNavClasses="nav-fill flex-column flex-sm-row nav-wrapper pt-0"
                        tabContentClasses="card shadow">

                        <tab-pane id="sessions">
                            <span slot="title">{{ $t('common.simulations') }}</span>
                            <simulations
                                :registration="registration"
                                :simulations="simulations"
                                :ratings="simulationsRatings"
                                :rating-options="ratingOptions"
                            ></simulations>
                        </tab-pane>

                        <tab-pane id="grid1">
                            <span slot="title">
                                {{ $t('common.competencies') }}
                                <span v-if="registration.degree.simulation_role_2 && hasSecondGrid">
                                    : {{ registration.degree.simulation_role_1_name[registration.degree.lang] }}
                                </span>
                            </span>
                            <competencies
                                :registration="registration"
                                :competencies="competencies1"
                                :ratings="competenciesRatings1"
                                :rating-options="ratingOptions"
                                :position="registration.degree.simulation_role_1"
                            ></competencies>
                        </tab-pane>

                        <tab-pane id="grid2" v-if="registration.degree.simulation_role_2 && hasSecondGrid">
                            <span slot="title">
                                {{ $t('common.competencies') }}:
                                {{ registration.degree.simulation_role_2_name[registration.degree.lang] }}
                            </span>
                            <competencies
                                :registration="registration"
                                :competencies="competencies2"
                                :ratings="competenciesRatings2"
                                :rating-options="ratingOptions"
                                :position="registration.degree.simulation_role_2"
                            ></competencies>
                        </tab-pane>
                    </tabs>

                </div>
                <div class="col-lg-5 order-lg-1">
                    <learners :registration="registration" :learners="learners"></learners>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Registration from '../dashboard/cohort/Registration';
    import Learners from './cohort/RegistrationResultsLearners'
    import Simulations from './cohort/RegistrationResultsSimulations'
    import Competencies from './cohort/RegistrationResultsCompetencies'

    export default {

        components: {
            Learners, Registration, Simulations, Competencies,
        },

        data() {
            return {
                registration: null,
                simulations: null,
                simulationsRatings: null,
                competencies1: null,
                competenciesRatings1: null,
                competencies2: null,
                competenciesRatings2: null,
                learners: null,
                ratingOptions: null,
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('reports.cohorts'),
                        route: '/astral/ui/reports/cohorts'
                    },
                    {
                        name: this.$t('reports.cohort-degrees'),
                        route: '/astral/ui/reports/cohorts/' + this.registration.cohort.id + '/degrees'
                    },
                    {
                        name: this.$t('reports.cohort-results'),
                    },
                ]
            },

            hasSecondGrid() {
                for (var index in this.simulations) {
                    if (this.simulations[index].grid2_id) {
                        return true
                    }
                }
                return false
            },
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/reports/registrations/'+to.params.registrationId+'/results')
            .then(resp => {
                next(vm => {
                    vm.registration = resp.data.data
                    vm.simulations = resp.data.included.simulations
                    vm.simulationsRatings = resp.data.included.simulations_ratings
                    vm.competencies1 = resp.data.included.competencies_1
                    vm.competenciesRatings1 = resp.data.included.competencies_ratings_1
                    vm.competencies2 = resp.data.included.competencies_2
                    vm.competenciesRatings2 = resp.data.included.competencies_ratings_2
                    vm.learners = resp.data.included.learners
                    vm.ratingOptions = resp.data.included.rating_options
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        },
    }
</script>
